import request from '../utils/request'

// 文章详情
export function contentDetails(params, token) {
    return request({
        url: '/content/details',
        method: 'get',
        params,
        headers: { token }
    })
}

// 文章详情
export function videoDetails(params, token) {
    return request({
        url: '/video/details',
        method: 'get',
        params,
        headers: { token }
    })
}

// 点赞
export function statisticsPraise(params, token) {
    return request({
        url: '/statistics/praise',
        method: 'get',
        params,
        headers: { token }
    })
}
